module.exports = {"demande_de_sav":"Demande de sav","un_souci_avec_un_produit_il_vous_suffit_de_commencer_une_nouvelle_demande_de_sav":"Un souci avec un produit ? Il vous suffit de commencer une demande de SAV.","commencer":"Commencer","mes_produits":"Mes produits","retrouver_tous_vos_produits":"Retrouver tous vos produits","consulter":"Consulter","mon_compte":"Mon compte","retrouver_toutes_les_informations_de_votre_compte":"Retrouver toutes les informations de votre compte","voir":"Voir"}


//////////////////
// WEBPACK FOOTER
// ./src/lang/default/fr/home/home.lang.json
// module id = w4NR
// module chunks = 1